export const ARTICLES_ES = [
  {
    id: "que-es-agente-ia",
    slug: "que-es-un-agente-de-ia",
    title: "¿Qué es un agente de IA y por qué tu empresa debería tener uno?",
    desc: "Qué es un agente de IA, en qué se diferencia de un chatbot y cómo las empresas los usan para vender y atender 24/7.",
    minutes: 5,
    date: "2026-07-02",
    wa: "ai",
    ctaTitle: "¿Quieres ver cómo se vería un agente de IA en tu empresa?",
    sections: [
      {
        h: "La definición simple",
        p: ["Un agente de IA es un sistema que entiende lenguaje natural, razona sobre el contexto y ejecuta acciones. A diferencia de un chatbot tradicional —que sigue un árbol de respuestas predefinidas— un agente puede consultar tu catálogo, agendar una reunión, registrar un lead en tu CRM o redactar una cotización, todo dentro de la misma conversación."],
      },
      {
        h: "Agente de IA vs chatbot tradicional",
        p: ["El chatbot clásico frustra: botones rígidos, respuestas genéricas y el temido 'no entendí tu pregunta'. El agente de IA entiende preguntas mal escritas, recuerda el contexto de la conversación y tiene acceso a herramientas: tu base de datos, tu calendario, tus documentos."],
        list: ["Chatbot: sigue flujos fijos, se rompe con lo inesperado", "Agente de IA: entiende intención, usa tus datos y ejecuta acciones", "Agente con handoff: deriva a humanos cuando el caso lo requiere"],
      },
      {
        h: "Casos de uso reales en empresas",
        p: ["En ventas: califica leads y agenda reuniones mientras tu equipo duerme. En atención: resuelve el 60-80% de las preguntas frecuentes al instante. En operaciones: consulta estados de pedido, stock o facturación sin que nadie intervenga."],
      },
      {
        h: "Lo que necesitas para partir",
        p: ["Menos de lo que crees: tus documentos comerciales, un canal (web o WhatsApp) y un caso de uso claro. Un primer agente funcional toma entre 2 y 4 semanas. La clave es partir acotado — un proceso, un canal — y escalar con resultados medidos."],
      },
    ],
    faqs: [
      { q: "¿Un agente de IA reemplaza personas?", a: "Reemplaza tareas, no personas: las preguntas repetitivas, la digitación y el seguimiento. Tu equipo queda para los casos que sí necesitan criterio humano." },
      { q: "¿Cuánto cuesta implementar uno?", a: "Nuestro plan DEVOLUZION AI parte en $299.990 CLP e incluye diagnóstico, un agente funcional, integración y capacitación." },
    ],
  },
  {
    id: "implementar-ia",
    slug: "como-implementar-ia-en-una-empresa",
    title: "Cómo implementar IA en una empresa (sin proyectos eternos)",
    desc: "Guía práctica para implementar inteligencia artificial en una empresa: diagnóstico, piloto acotado, medición y escala.",
    minutes: 6,
    date: "2026-07-05",
    wa: "ai",
    ctaTitle: "Agenda un diagnóstico de IA para tu empresa",
    sections: [
      {
        h: "El error más común",
        p: ["La mayoría de los proyectos de IA fracasan por empezar demasiado grande: 'transformar la empresa con IA'. Los que funcionan empiezan ridículamente concretos: automatizar la primera respuesta a leads, resumir actas de reunión, clasificar correos de soporte."],
      },
      {
        h: "Paso 1: Diagnóstico de oportunidades",
        p: ["Antes de hablar de tecnología, mapea dónde se pierden horas. Pregunta a cada área: ¿qué tarea repetitiva odias? ¿Qué pregunta respondes 20 veces al día? Ahí están los primeros casos de uso. Prioriza por impacto (horas ahorradas o ingresos generados) y esfuerzo (datos disponibles, integraciones necesarias)."],
      },
      {
        h: "Paso 2: Piloto de 30 días",
        p: ["Elige UN caso de uso y ejecútalo como piloto acotado: un canal, un proceso, métricas definidas antes de partir. Un piloto bien acotado cuesta poco y responde la única pregunta que importa: ¿esto le devuelve valor a mi empresa?"],
      },
      {
        h: "Paso 3: Medir y escalar",
        p: ["Define la línea base antes del piloto (tiempo de respuesta, horas semanales, tasa de conversión) y compara después. Si el piloto funciona, escala a más canales o procesos. Si no funciona, aprendiste barato y el siguiente intento será mejor."],
      },
      {
        h: "El factor humano",
        p: ["La IA que no se adopta no sirve. Capacita a tu equipo, nombra un responsable interno y celebra los primeros resultados visibles. La transformación la hace la gente; la IA solo la acelera."],
      },
    ],
    faqs: [
      { q: "¿Necesito un área de tecnología para implementar IA?", a: "No. Necesitas un socio técnico y un responsable interno que conozca el negocio. La tecnología la ponemos nosotros; el conocimiento del proceso lo pones tú." },
      { q: "¿Cuánto cuesta un piloto de IA?", a: "Un piloto acotado parte en torno a los $299.990 CLP con nuestro plan DEVOLUZION AI, incluyendo diagnóstico y puesta en marcha." },
    ],
  },
  {
    id: "costo-web-chile",
    slug: "cuanto-cuesta-una-pagina-web-en-chile",
    title: "¿Cuánto cuesta una página web en Chile en 2026?",
    desc: "Precios reales de páginas web en Chile: qué incluye cada rango, qué diferencia una web barata de una premium y cómo no pagar de más.",
    minutes: 6,
    date: "2026-07-08",
    wa: "web",
    ctaTitle: "Cotiza tu página web con DEVOLUZION",
    sections: [
      {
        h: "Los rangos reales del mercado",
        p: ["En Chile, una página web puede costar desde $200.000 CLP (plantilla básica) hasta decenas de millones (plataformas complejas). La pregunta correcta no es cuánto cuesta, sino qué incluye y qué retorno genera."],
        list: ["$200.000 - $500.000: plantillas con tu logo. Rápidas, genéricas, sin estrategia", "$500.000 - $2.000.000: sitios personalizados con diseño y SEO básico", "$2.000.000+: experiencias premium, ecommerce, funcionalidades a medida"],
      },
      {
        h: "Qué diferencia una web premium",
        p: ["Tres cosas: velocidad (Core Web Vitals en verde), conversión (estructura pensada para vender, no para lucir) y SEO técnico desde el código. Una web premium no es un lujo: es la diferencia entre un sitio que da confianza y uno que la destruye en 3 segundos."],
      },
      {
        h: "Los costos ocultos que nadie menciona",
        p: ["Hosting y dominio ($50.000-$300.000/año), mantenimiento, licencias de plugins y — el más ignorado — el costo de una web lenta o genérica: cada cliente que no te contacta porque tu sitio no inspiró confianza."],
      },
      {
        h: "Cómo evaluar una cotización",
        p: ["Pide que detalle: diseño personalizado o plantilla, SEO técnico incluido, velocidad objetivo, quién escribe los contenidos, qué pasa con el soporte post-lanzamiento y de quién es el código. Una cotización seria responde todo eso sin que lo preguntes dos veces."],
      },
      {
        h: "Nuestra referencia",
        p: ["En DEVOLUZION, el plan START parte en $149.990 CLP + impuestos e incluye web premium, UX/UI, SEO técnico inicial, analytics, WhatsApp y formulario. Sin letra chica."],
      },
    ],
    faqs: [
      { q: "¿Una web gratis o barata sirve para partir?", a: "Para validar una idea, sí. Para una empresa que vende, una web genérica suele costar más en clientes perdidos de lo que ahorra." },
      { q: "¿El precio incluye aparecer en Google?", a: "El SEO técnico (estructura, metadata, sitemap) debe estar incluido. Posicionar para keywords competitivas es un trabajo continuo adicional." },
    ],
  },
  {
    id: "costo-software",
    slug: "cuanto-cuesta-desarrollar-software-a-medida",
    title: "¿Cuánto cuesta desarrollar un software a medida?",
    desc: "Factores que determinan el costo de un software a medida, rangos de referencia y cómo evitar proyectos que nunca terminan.",
    minutes: 6,
    date: "2026-07-11",
    wa: "software",
    ctaTitle: "Conversemos sobre el software que tu empresa necesita",
    sections: [
      {
        h: "Por qué nadie puede darte un precio sin conversar",
        p: ["Desarrollar software es como construir una casa: el precio depende de metros, materiales y terminaciones. Un sistema de gestión simple puede costar unos pocos millones de CLP; una plataforma con integraciones, roles y reportes, bastante más. Desconfía de quien cotiza sin hacer preguntas."],
      },
      {
        h: "Los factores que mueven el precio",
        p: ["Número de usuarios y roles, integraciones con otros sistemas (ERP, contabilidad, facturación), complejidad de los flujos de aprobación, reportes y dashboards, y requisitos de seguridad. Cada 'y también sería bueno...' suma."],
      },
      {
        h: "El enfoque MVP: pagar menos por aprender más",
        p: ["La forma inteligente de partir: una primera versión con solo lo esencial, en 4 a 8 semanas, con alcance y precio cerrados. La usas, aprendes qué falta de verdad y recién ahí inviertes en la fase dos. Menos riesgo, más aprendizaje."],
      },
      {
        h: "Cómo evitar el proyecto eterno",
        p: ["Exige: alcance escrito por fases, entregas visibles cada semana, ambiente de pruebas donde veas el avance real y propiedad del código desde el día uno. Si el proveedor no ofrece esas cuatro cosas, es señal de alerta."],
      },
    ],
    faqs: [
      { q: "¿Software a medida o un producto existente?", a: "Si un SaaS resuelve tu proceso sin forzarlo, úsalo. El software a medida se justifica cuando tu proceso es tu ventaja competitiva o cuando las licencias por usuario ya cuestan más que construir." },
      { q: "¿Quién es dueño del código?", a: "En DEVOLUZION, tú: código, documentación e infraestructura. Exige lo mismo a cualquier proveedor." },
    ],
  },
  {
    id: "automatizar-con-ia",
    slug: "que-puede-automatizar-una-empresa-con-ia",
    title: "Qué puede automatizar una empresa con IA (con ejemplos reales)",
    desc: "Procesos que la IA puede automatizar hoy en tu empresa: ventas, atención, operaciones y back-office, con ejemplos concretos.",
    minutes: 5,
    date: "2026-07-14",
    wa: "ai",
    ctaTitle: "Descubramos qué automatizar primero en tu empresa",
    sections: [
      {
        h: "Ventas: nunca más un lead frío",
        p: ["Respuesta en segundos a cada lead que llega — a cualquier hora. Calificación automática con tus criterios, seguimiento persistente por WhatsApp y email, y agendamiento directo en el calendario de tus vendedores. El efecto típico: más reuniones con el mismo tráfico."],
      },
      {
        h: "Atención al cliente: el 70% se responde solo",
        p: ["Estado de pedidos, horarios, precios, políticas de cambio: un agente entrenado con tu información resuelve la mayoría de las consultas al instante y deriva el resto con contexto completo."],
      },
      {
        h: "Operaciones y back-office",
        p: ["Clasificación de correos y documentos, extracción de datos de facturas, generación de reportes diarios, actualización de planillas entre sistemas. Lo que tu equipo hace 'copiando y pegando' es exactamente lo que mejor automatiza la IA."],
      },
      {
        h: "Marketing: más iteraciones, mejor puntería",
        p: ["Variantes de anuncios, segmentación asistida, resúmenes de resultados y alertas cuando una métrica se mueve. La IA no reemplaza la estrategia: la acelera."],
      },
      {
        h: "Por dónde partir",
        p: ["La regla: automatiza primero lo repetitivo, frecuente y con reglas claras. Si una tarea se hace igual 20 veces a la semana, es candidata. Si requiere juicio complejo cada vez, déjala en humanos — por ahora."],
      },
    ],
  },
  {
    id: "web-vs-ecommerce",
    slug: "pagina-web-vs-ecommerce",
    title: "Página web vs Ecommerce: ¿qué necesita tu negocio?",
    desc: "Diferencias entre una página web y una tienda ecommerce, cuándo conviene cada una y cómo evolucionar de una a otra.",
    minutes: 4,
    date: "2026-07-17",
    wa: "ecommerce",
    ctaTitle: "Te ayudamos a decidir con números de tu negocio",
    sections: [
      {
        h: "La diferencia esencial",
        p: ["Una página web presenta, persuade y genera contacto. Un ecommerce vende directamente: catálogo, carrito, pago y despacho sin intervención humana. La primera convierte visitas en conversaciones; la segunda, en transacciones."],
      },
      {
        h: "Cuándo una página web es suficiente",
        p: ["Si vendes servicios, productos de alto valor con cotización, o tu ciclo de venta requiere conversación (B2B, proyectos, consultoría), una gran página web con buen formulario y WhatsApp rinde más que una tienda forzada."],
      },
      {
        h: "Cuándo necesitas ecommerce",
        p: ["Si vendes productos de compra recurrente, tu catálogo supera las 20-30 referencias, o tus clientes preguntan constantemente precios y stock, el ecommerce deja de ser opcional: cada venta manual es margen perdido."],
      },
      {
        h: "El camino inteligente",
        p: ["Muchas empresas parten con web premium + catálogo sin pago (los pedidos llegan por WhatsApp) y evolucionan a checkout completo cuando el volumen lo justifica. La arquitectura correcta permite crecer sin rehacer todo."],
      },
    ],
    faqs: [
      { q: "¿Puedo partir con web y agregar ecommerce después?", a: "Sí, si la base está bien construida. Nuestros sitios se desarrollan pensando en esa evolución: catálogo, pagos y automatización se agregan sin rehacer la web." },
      { q: "¿Cuánto cuesta cada uno?", a: "Web premium desde $149.990 CLP (plan START); ecommerce desde $499.990 CLP (plan COMMERCE). Ambos con SEO técnico y analytics incluidos." },
    ],
  },
  {
    id: "que-hace-agencia",
    slug: "que-hace-una-agencia-de-marketing-digital",
    title: "¿Qué hace una agencia de marketing digital (y cómo elegir una buena)?",
    desc: "Qué hace realmente una agencia de marketing digital, qué servicios debe ofrecer y las señales para elegir una seria.",
    minutes: 5,
    date: "2026-07-20",
    wa: "growth",
    ctaTitle: "Conversa con DEVOLUZION sobre tu crecimiento",
    sections: [
      {
        h: "Lo que debería hacer",
        p: ["Una agencia seria hace cuatro cosas: estrategia (a quién le vendes y por qué te eligen), ejecución (campañas, contenidos, SEO), medición (qué volvió por cada peso invertido) y optimización (mejorar el mes siguiente con lo aprendido). Todo lo demás es accesorio."],
      },
      {
        h: "Servicios típicos, explicados",
        p: ["Google Ads para capturar demanda existente, Meta Ads para generar demanda nueva, SEO para no pagar cada clic para siempre, email/WhatsApp marketing para venderle a quien ya te conoce y analytics para saber qué funcionó."],
      },
      {
        h: "Señales de una buena agencia",
        p: ["Habla de ventas y costo por cliente, no de likes. Te muestra dashboards en vivo, no PDFs bonitos. Te dice qué NO haría en tu caso. Y la cuenta publicitaria queda a tu nombre."],
        list: ["Reporta leads y ventas, no impresiones", "La cuenta de Ads es tuya", "Propone antes de prometer", "Te explica sin jerga"],
      },
      {
        h: "Señales de alerta",
        p: ["Promesas de primer lugar en Google en dos semanas, reportes que no puedes verificar, contratos largos sin resultados mínimos y la frase 'confía en nosotros' como respuesta a preguntas de números."],
      },
    ],
  },
  {
    id: "seo-vs-ads",
    slug: "seo-vs-google-ads",
    title: "SEO vs Google Ads: ¿en qué invertir primero?",
    desc: "SEO o Google Ads: diferencias, costos, tiempos de resultado y cómo combinarlos para maximizar el retorno.",
    minutes: 5,
    date: "2026-07-23",
    wa: "growth",
    ctaTitle: "Te decimos honestamente qué conviene en tu caso",
    sections: [
      {
        h: "La diferencia en una frase",
        p: ["Google Ads compra visibilidad inmediata; el SEO construye visibilidad que no se paga por clic. Uno es arriendo, el otro es propiedad."],
      },
      {
        h: "Cuándo gana Google Ads",
        p: ["Cuando necesitas resultados este mes, cuando validas un mercado nuevo, o en rubros donde el primer resultado orgánico tarda años. Ads también te enseña qué keywords convierten — información que luego usa tu SEO."],
      },
      {
        h: "Cuándo gana el SEO",
        p: ["Cuando tu cliente busca antes de comprar (la mayoría de los casos), cuando el costo por clic de tu industria es alto, y cuando piensas en años, no en semanas. El tráfico orgánico compone: cada mes se suma al anterior."],
      },
      {
        h: "La respuesta correcta: ambos, con orden",
        p: ["La estrategia que mejor rinde: Ads desde el día uno para generar flujo y aprender qué convierte; SEO en paralelo para que en 6-12 meses una parte creciente de tu tráfico deje de costar por clic. El presupuesto se va moviendo con los datos."],
      },
    ],
    faqs: [
      { q: "¿Cuánto hay que invertir en cada uno?", a: "Depende del CPC de tu industria y de tu capacidad de atender leads. En una primera conversación estimamos ambos escenarios con datos de tu rubro." },
      { q: "¿El SEO funciona para empresas chicas?", a: "Sí, especialmente con SEO local y keywords de nicho. Las empresas chicas ganan donde las grandes no se molestan en competir." },
    ],
  },
  {
    id: "automatizar-whatsapp",
    slug: "como-automatizar-whatsapp-para-empresas",
    title: "Cómo automatizar WhatsApp para empresas (sin que te bloqueen)",
    desc: "Guía para automatizar WhatsApp Business con la API oficial: respuestas, seguimiento y ventas automáticas sin riesgo de bloqueo.",
    minutes: 5,
    date: "2026-07-26",
    wa: "automation",
    ctaTitle: "Automatiza tu WhatsApp con DEVOLUZION",
    sections: [
      {
        h: "Por qué WhatsApp es EL canal en Latinoamérica",
        p: ["Tus clientes no revisan el email: revisan WhatsApp. Las tasas de apertura superan el 90% y la respuesta es casi inmediata. El problema: atenderlo a mano no escala, y dejarlo sin responder mata ventas."],
      },
      {
        h: "La regla de oro: API oficial o nada",
        p: ["Existen herramientas piratas que automatizan WhatsApp Web. Funcionan... hasta que bloquean tu número para siempre. La vía correcta es la API oficial de WhatsApp Business: plantillas aprobadas, opt-in de clientes y cero riesgo de perder tu número."],
      },
      {
        h: "Qué automatizar primero",
        p: ["La primera respuesta (nadie espera más de 5 minutos), la clasificación del contacto (ventas, soporte, información), el agendamiento (directo a tu calendario) y el seguimiento (cotizaciones que no se enfrían). Con esas cuatro, el 80% del valor está capturado."],
        list: ["Respuesta instantánea 24/7", "Clasificación y derivación automática", "Agendamiento con recordatorios", "Seguimiento de cotizaciones", "Registro en CRM"],
      },
      {
        h: "El humano sigue siendo clave",
        p: ["La automatización atiende lo repetitivo y deriva lo complejo con contexto. El cliente nota rapidez y orden, no un robot. Ese equilibrio — instantáneo pero humano cuando importa — es lo que convierte."],
      },
    ],
  },
  {
    id: "ia-aumentar-ventas",
    slug: "como-utilizar-ia-para-aumentar-ventas",
    title: "Cómo utilizar IA para aumentar ventas (sin humo)",
    desc: "Formas concretas en que la IA aumenta ventas: velocidad de respuesta, seguimiento, personalización y predicción de demanda.",
    minutes: 5,
    date: "2026-07-29",
    wa: "ai",
    ctaTitle: "Hablemos de IA aplicada a tus ventas",
    sections: [
      {
        h: "Velocidad de respuesta = ventas",
        p: ["El dato que nadie quiere escuchar: el lead que espera más de una hora casi no convierte. La IA responde en segundos, a cualquier hora, todos los días. Solo eso — sin cambiar nada más — suele mover el número de reuniones agendadas."],
      },
      {
        h: "Seguimiento que ningún humano sostiene",
        p: ["El 80% de las ventas requiere 5+ contactos; la mayoría de los vendedores abandona al segundo. Una secuencia con IA hace seguimiento persistente y elegante por WhatsApp y email hasta que el lead dice sí, dice no, o agenda."],
      },
      {
        h: "Personalización a escala",
        p: ["La IA adapta mensajes, ofertas y contenidos según lo que sabe de cada cliente: qué miró, qué compró, qué preguntó. Lo que antes era imposible fuera de Amazon, hoy está al alcance de una PyME."],
      },
      {
        h: "Predecir para vender mejor",
        p: ["Con tus datos históricos, la IA estima qué clientes están por comprar, cuáles están por irse y qué productos empujar cada mes. Vender deja de ser intuición y pasa a ser priorización informada."],
      },
      {
        h: "Por dónde empezar esta semana",
        p: ["Pregunta simple: ¿cuántos leads dejaron de recibir respuesta el mes pasado? Ese número, multiplicado por tu ticket promedio, es el costo de no partir. El primer paso es un agente comercial que responde, califica y agenda."],
      },
    ],
  },
];
